/* eslint-disable @typescript-eslint/no-unused-vars */
// Log event with basic info
export const useLogEventWithBasic = () => {
  return (
    eventName: string,
    value?: string | number | null,
    extraMetadata?: Record<string, string> | null,
  ) => {
    // Do nothing for now
  };
};
